<template>
  <div class="register-photographer-wrapper">
    <div class="register-form-container">
      <div class="q-mb-lg text-center">
        <p class="text-body1 text-weight-medium q-mb-md">
          {{ $t('userPanel.registerPhotographerTitle') }}
        </p>
      </div>

      <div class="row q-col-gutter-md q-mb-lg">
        <div class="col-12 col-md-6">
          <div
            class="bg-blue-1 text-blue-9 q-pa-md rounded-borders full-height"
          >
            <div class="row items-center q-mb-sm">
              <q-icon name="info" size="sm" class="q-mr-sm" />
              <span class="text-weight-bold">
                {{ $t('userPanel.accountVerificationTitle') }}
              </span>
            </div>
            <div class="text-caption">
              {{ $t('userPanel.accountVerificationInfo') }}
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div
            class="bg-orange-1 text-orange-9 q-pa-md rounded-borders full-height"
          >
            <div class="row items-center q-mb-sm">
              <q-icon name="warning" size="sm" class="q-mr-sm" />
              <span class="text-weight-bold">
                {{ $t('userPanel.shareConsentTitle') }}
              </span>
            </div>
            <div class="text-caption">
              {{ $t('userPanel.shareConsentInfo') }}
            </div>
          </div>
        </div>
      </div>

      <q-card flat bordered class="q-pa-md q-pa-sm-lg shadow-1">
        <q-form ref="form" @submit.prevent="submit" class="q-gutter-y-md">
          <q-input
            ref="email"
            square
            clearable
            v-model="email"
            type="email"
            lazy-rules
            :rules="[required, isEmail, short]"
            :label="$t('login.email')"
            hide-bottom-space
          >
            <template v-slot:prepend>
              <q-icon name="email" />
            </template>
          </q-input>

          <q-input
            ref="username"
            square
            clearable
            v-model="username"
            lazy-rules
            :rules="[required, short]"
            type="text"
            :label="$t('login.username')"
            hide-bottom-space
          >
            <template v-slot:prepend>
              <q-icon name="person" />
            </template>
          </q-input>

          <q-input
            ref="portfolio"
            square
            v-model="portfolio"
            type="text"
            :label="$t('login.portfolio')"
            :rules="[isPortfolioUrl]"
            hide-bottom-space
            prefix="https://"
          >
            <template v-slot:prepend>
              <q-icon name="link" />
            </template>
          </q-input>

          <q-card-actions class="q-px-none q-pt-md justify-center">
            <q-btn
              unelevated
              size="lg"
              color="primary"
              type="submit"
              class="text-white text-weight-bold"
              style="width: 100%; max-width: 300px"
              :label="$t('common.submit')"
              :loading="isLoading"
            />
          </q-card-actions>
        </q-form>
      </q-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Notify } from 'quasar';
import { validationMethods as validate } from '@/services/validation.service';

export default {
  name: 'RegisterPhotographerForm',
  data() {
    return {
      email: '',
      username: '',
      portfolio: '',
      isLoading: false,
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.global.lang,
    }),
  },
  watch: {
    lang() {
      this.$refs.form?.resetValidation();
    },
  },
  methods: {
    ...mapActions({
      registerPhotographerByOrganizer: 'auth/registerPhotographerByOrganizer',
    }),
    required(val) {
      return validate.required(val, this.$t);
    },
    short(val) {
      return validate.short(val, this.$t);
    },
    isEmail(val) {
      return validate.isEmail(val, this.$t);
    },
    isPortfolioUrl(val) {
      return validate.isPortfolioUrl(val, this.$t);
    },
    async submit() {
      this.isLoading = true;
      try {
        await this.registerPhotographerByOrganizer({
          username: this.username,
          email: this.email,
          portfolio: `https://${this.portfolio}`,
        });
        Notify.create({
          icon: 'done',
          color: 'positive',
          position: 'bottom',
          message: this.$t('success.registerPhotographer'),
        });
        this.email = '';
        this.username = '';
        this.portfolio = '';

        this.$refs.form?.resetValidation();

        this.$router.push({ path: '/userPanel', query: { tab: 'profile' } });
      } catch (error) {
        const errorMessage = error?.response?.data?.message;

        Notify.create({
          icon: 'warning',
          color: 'negative',
          message:
            errorMessage || this.$t('error.organizer.photographer.generic'),
          position: 'bottom',
          timeout: 5000
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.register-photographer-wrapper {
  display: flex;
  justify-content: center;
  padding: 1rem;
}

.register-form-container {
  width: 100%;
  max-width: 800px;
}
</style>
